import React, { useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import { useTimesheetProvider } from "../../../../Providers/Consultant/Timesheet";
import CustomTable from "../../../../Components/Table";

const headCells = [
  { disablePadding: true, label: "Week" },
  { disablePadding: false, label: "Hours" },
  { disablePadding: false, label: "Status" },
  { disablePadding: false, label: "" },
];

export default function WeeklyTimesheet({ setModalOpen, setTimesheets }) {
  const { selectedJobDetails, timesheetMaster, setSelectedTimesheet } =
    useTimesheetProvider();

  const CustomRow = ({ row }) => {
    const start = moment.utc(row.start);
    const end = moment.utc(row.end);
    const format = start.isSame(end, "year") ? "MMM D" : "MMM D, YY";

    useEffect(() => {
      setTimesheets(timesheetMaster[selectedJobDetails?.job?.id] ?? [])
    }, [])

    return (
      <TableRow tabIndex={-1} key={row.id}>
        <TableCell component="th" scope="row" padding="none">
          <span>{start.format(format)}</span>
          <span className="mx-1.5">-</span>
          <span>{end.format(format)}</span>
        </TableCell>
        <TableCell align="left">
          {row.hours.toString().padStart(2, "0")}:
          {row.minutes.toString().padStart(2, "0")}
        </TableCell>
        <TableCell align="left">
          {row.status[0] + row.status.slice(1).toLowerCase()}
        </TableCell>
        <TableCell
          align="left"
          className="cursor-pointer"
          onClick={() => {
            setModalOpen(true);
            setSelectedTimesheet(row.id);
          }}
        >
          <span className="text-blue-400">View Timesheet</span>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <CustomTable
      title="Timesheets"
      headCells={headCells}
      rows={timesheetMaster[selectedJobDetails?.job?.id] ?? []}
      CustomRow={CustomRow}
    />
  );
}
